<span class="test">
  <button
    class="dialpad-button"
    [ngClass]="{ isActive: isActive }"
    (mousedown)="down()"
    (mouseup)="up()"
  >
    <span class="dialpad-button-number" [innerHTML]="dtmfKey"></span>
    <span class="dialpad-button-letters" [innerHTML]="dtmfLetters"></span>
  </button>
</span>
